{
  "Billing": "Faturação",
  "Return to App": "Voltar à aplicação",
  "Home": "Início",
  "Calendar": "Calendário",
  "Dashboard": "Painel",
  "ATP": "ATP",
  "Subscriptions": "Subscrições",
  "Payment Methods": "Métodos de pagamento",
  "Purchases": "Compras",
  "View Profile": "Ver perfil",
  "TrainingPeaks Athlete Since": "Atleta TrainingPeaks desde",
  "TrainingPeaks Coach Since": "Treinador TrainingPeaks desde",
  "Invoice": "Fatura",
  "No results": "Sem resultados",
  "qtr": "trim.",
  "Show all transactions": "Mostrar todas as transações",
  "No transactions found": "Não foram encontradas transações",
  "Loading purchases": "A carregar compras",
  "Error loading purchases": "Erro ao carregar compras",
  "Active": "Ativa",
  "Inactive": "Inativa",
  "Cancelled": "Cancelada",
  "PastDue": "Em atraso",
  "Trialing": "Em período experimental",
  "Next Renewal": "Próxima renovação",
  "Manage": "Gerir",
  "plus tax": "mais impostos",
  "No subscriptions found": "Não foram encontradas subscrições",
  "No purchases found": "Não foram encontradas compras",
  "Show all": "Mostrar tudo",
  "Show less": "Mostrar menos",
  "Date": "Data",
  "Description": "Descrição",
  "Amount": "Montante",
  "Status": "Estado",
  "Paid": "Paga",
  "Failed": "Falhada",
  "Pending": "Pendente",
  "Refunded": "Reembolsada",
  "Loading": "A carregar",
  "Error loading data": "Erro ao carregar dados",
  "month": "mês",
  "year": "ano",
  "quarter": "trimestre",
  "mo": "mês",
  "yr": "ano",
  "Default": "Predefinido",
  "Expires": "Expira",
  "Card ending in": "Cartão terminado em",
  "Flexible planning to fit your life": "Planeamento flexível para se adaptar à sua vida",
  "Actionable Insights to keep you on track": "Informações úteis para o manter no rumo certo",
  "Strength training to avoid injury": "Treino de força para evitar lesões",
  "Ride the world inside on Virtual": "Pedale pelo mundo em casa com o Virtual",
  "Any sport, any device, any time": "Qualquer desporto, qualquer dispositivo, a qualquer hora",
  "Annual": "Anual",
  "Monthly": "Mensal",
  "Billed USD $134.99/yr": "Faturado: 134,99 USD/ano",
  "Most Popular": "Mais popular",
  "$19.95 $11.25/mo": "19,95 $ 11,25 $/mês",
  "$19.95/mo": "19,95 $/mês",
  "Checkout": "Finalizar compra",
  "Progress starts with Premium.": "O progresso começa com o Premium.",
  "Add Card": "Adicionar cartão",
  "Close": "Fechar",
  "Primary": "Principal",
  "Delete": "Eliminar",
  "Make Primary": "Definir como principal",
  "Error loading payment methods": "Erro ao carregar métodos de pagamento",
  "Your card has expired. Please add a new card.": "O seu cartão expirou. Adicione um novo cartão.",
  "Unable to load payment form. Please try again later.": "Não foi possível carregar o formulário de pagamento. Tente novamente mais tarde.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "Será efetuada uma cobrança temporária de 1,00 USD para validar o seu método de pagamento. Esta cobrança será automaticamente reembolsada.",
  "Payment method added successfully": "Método de pagamento adicionado com êxito",
  "Default payment method updated": "Método de pagamento predefinido atualizado",
  "Payment method deleted": "Método de pagamento eliminado",
  "Failed to set default payment method": "Não foi possível definir o método de pagamento predefinido",
  "Failed to update default payment method": "Não foi possível atualizar o método de pagamento predefinido",
  "Failed to delete payment method": "Não foi possível eliminar o método de pagamento",
  "Maximize Your Premium Subscription \n Before You Go!": "Tire o máximo partido da sua subscrição Premium\nantes de sair!",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Pedale em casa com a nossa experiência de ciclismo virtual",
  "Strength Builder": "Criador de treinos de força",
  "Create and save strength workouts": "Crie e guarde treinos de força",
  "Metrics Charts": "Gráficos de métricas",
  "Analyze metrics from your synced devices": "Analise métricas dos seus dispositivos sincronizados",
  "Performance Metrics": "Métricas de desempenho",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Condição física (CTL), fadiga (ATL) e forma (TSB)",
  "Peak Performances": "Melhores desempenhos",
  "Track and compare your best efforts": "Acompanhe e compare os seus melhores esforços",
  "NEW!": "NOVO!",
  "Cancel Subscription": "Cancelar subscrição",
  "Renew Subscription": "Renovar subscrição",
  "Complimentary": "Gratuita",
  "Your complimentary access is active through": "O seu acesso gratuito está ativo até",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Mantenha os seus objetivos à vista - renove o Premium para se manter no rumo certo até ao dia da prova.",
  "Renew": "Renovar",
  "Auto-Renew Off": "Renovação automática desativada",
  "Access through": "Acesso até",
  "Turn Auto-Renew On": "Ativar renovação automática",
  "Are you sure you want to cancel coaching?": "Tem a certeza de que pretende cancelar o coaching?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Alcançar os seus objetivos exige o acompanhamento certo. Antes de cancelar, diga-nos se precisa de pausar, ajustar o nível do seu pacote ou falar diretamente com um especialista do Coach Match.",
  "Pause, Adjust, or Contact Support": "Pausar, ajustar ou contactar o suporte",
  "Yes, Cancel": "Sim, cancelar",
  "Keep My Coaching": "Manter o meu coaching",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Subscrição Coach Match: Pausar, ajustar ou falar com um especialista",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Olá equipa Coach Match,\n\nEntro em contacto relativamente à minha subscrição de coaching. Antes de decidir se pretendo cancelar, gostaria de [pausar a minha subscrição / ajustar o nível do meu pacote / falar com um especialista do Coach Match].\n\nO meu e-mail de conta é: [O seu e-mail]\n\nObrigado(a)!",
  "Before you go...": "Antes de sair...",
  "What's the reason for canceling?": "Qual é o motivo do cancelamento?",
  "Price / Financial Reasons": "Preço / Motivos financeiros",
  "The subscription cost no longer fits my budget.": "O custo da subscrição já não se adequa ao meu orçamento.",
  "Injured / Health Reasons": "Lesão / Motivos de saúde",
  "I'm unable to train due to injury or health.": "Não consigo treinar devido a lesão ou saúde.",
  "Finished Goal Event": "Evento objetivo concluído",
  "I completed my target race or event.": "Completei a minha corrida ou evento alvo.",
  "Poor Experience / Fit": "Experiência negativa / Não se adequou",
  "The coaching style or program wasn't the right match.": "O estilo de coaching ou o programa não era o mais adequado.",
  "Temporary Pause / Restart Later": "Pausa temporária / Retomar mais tarde",
  "Life got busy — I'd like to come back when I'm ready.": "A vida ficou agitada — gostaria de voltar quando estiver pronto(a).",
  "Other": "Outro",
  "Optional: Why?": "Opcional: Porquê?",
  "Continue": "Continuar",
  "Keep Subscription": "Manter subscrição"
}
